// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3uPsQ","content":"ManualTimeModal_content__2Eqxz"};